import BaseMapper from '../../BaseMapper';
import { LANGUAGES } from '../../../constants/defaultValues';
import { store } from '../../../store';

const SeasonMapper = (data, context) => {
    const reduxStore = store.getState();

    const { locale } = reduxStore.settings;

    data.categoryName = context.category.names[locale] || context.category.names[LANGUAGES.eng];
    data.events = [];
    data.seasonName = data.names[locale] || data.names[LANGUAGES.eng];

    return data;
};

export default SeasonMapper;
